import { Props } from "./types";

const VerticalBar = ({ className }: Props): JSX.Element => {
  return <div className={`${className} w-px h-full bg-grey-200`} />;
};

export default VerticalBar;
